/** Solid vs dashed segment between consecutive GPS points (see MapConst.MINUTES_LIMIT_SOLID_LINE). */
export enum TrackingSegmentStyleEnum {
  Solid = 0,
  Dashed = 1,
}
